// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___sCboz","root__wrapper":"style-module__root__wrapper___ytU8o","root__slider":"style-module__root__slider___Mygw4","root__item":"style-module__root__item___kwQvM","root__title":"style-module__root__title___YrzO1","root__description":"style-module__root__description___w2GG4","root__image":"style-module__root__image___EmjNc"};
    if(module.hot) {
      // 1744730408265
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  